import { ThrowStmt } from '@angular/compiler';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SharedUtil } from 'src/app/core/utils/SharedUtil';
import { Eleicao } from 'src/app/models/eleicao.model';
import { Gestor } from 'src/app/models/gestor.model';
import { GestoresService } from 'src/app/services/gestores.service';
import { LoginService } from 'src/app/services/login-participante.service';
import { StorageService } from 'src/app/services/storage.service';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import{ NgxSpinnerService } from 'ngx-spinner'
import { GestorDTO } from 'src/app/models/gestorDTO.model';
import { Plataforma } from  'src/app/models/plataforma.model'
import { PlataformaService } from 'src/app/services/plataforma.service';
import { $ } from 'jquery'
import { Assistente } from 'src/app/models/assistente.model';
import { CandidaturaService } from 'src/app/services/candidatura.service';
@Component({
  selector: 'app-lista-gestores',
  templateUrl: './lista-gestores.component.html',
  styleUrls: ['./lista-gestores.component.css']
})

export class ListaGestoresComponent implements OnInit {
  resposta: any;
  desabilitaBotao: boolean;
  listaDeGestores: any;
  listaDeEleicoes: any;
  listaDeAssistentes: any;
  listaPlataformas: any;
  formGroup: FormGroup;
  token: string;
  senha: string;
  confirmacaoSenha: string;
  ativo: boolean;
  gestor = new Gestor;
  assistente = new Assistente;
  gestorModalSelecionado: any;
  assistenteModalSelecionado: any;
  password: any;
  semAssistentes: boolean;

  constructor(    
      protected loginServices: LoginService,
      public route: ActivatedRoute,
      protected router: Router,
      protected gestores: GestoresService,
      protected candidaturasService: CandidaturaService,
      protected plataformas: PlataformaService,
      protected spinner: NgxSpinnerService,
      protected messageService: MessageService,
      private frmBuilder: FormBuilder
  ) { }

  ngOnInit() {

    this.formGroup = new FormGroup({
      senha: new FormControl(),
      confirmacaoSenha: new FormControl()
   });

   this.token = sessionStorage.getItem('token');

    this.gestores.buscarTodosGestores(this.token).then( 
      g => {
      this.listaDeGestores = g
      console.log(this.listaDeGestores)
      this.spinner.hide();
    });    
  }

  alterarSituacaoDoGestor(idGestor,ativo){
    this.ativo = !ativo

    this.gestores.alterarGestor(this.token,idGestor,this.ativo);
    window.location.reload();
  }

  alterarSituacaoDoAssistente(idAssistente,ativo){
    this.ativo = !ativo

    this.gestores.alterarAssistente(this.token,idAssistente,this.ativo);
    window.location.reload();
  }

  async buscarEleicoesPorId(id){
    await this.gestores.buscarEleicaoPorIdGestor(this.token,id).then((data: any) => {
      this.listaDeEleicoes = data;
      console.log(this.listaDeEleicoes)
      console.log(this.listaDeEleicoes)
    });
  }

  async buscarAssistentesPorId(idGestor){
    sessionStorage.setItem('idGestor', String(idGestor));
    await this.gestores.buscarAssistentesPorIdGestor(this.token,idGestor).then((data: any) => {
      this.listaDeAssistentes = data;
      console.log(this.listaDeAssistentes)
      if(data == null || data.length == 0){
        this.semAssistentes = true;
      }else {
        this.semAssistentes = false;
      }
      this.spinner.hide();
    });
  }

  async buscarPlataformas(){
    await this.plataformas.listar(this.token).then((data: any) => {
      this.listaPlataformas = data;
      console.log(this.listaPlataformas)
      console.log(this.listaPlataformas)
    });
  }

  public logout(){
    this.loginServices.logout();
    this.router.navigate(['/login'])
  }

  cadastrarNovoGestor(){
    this.router.navigate(['cadastro-gestor'], { relativeTo: this.route });
  }

  cadastrarNovoAssistente(idGestor){
    this.router.navigate(['cadastro-assistente'], { relativeTo: this.route });
  }

  iniciarEleicoesAutomaticamente(){
    let resposta;
    try {
      resposta = this.gestores.getExecInicioEleicaoAuto(this.token);
    }
    catch {
      return 0
    }
    if (resposta)
      this.messageService.add({ key: 'toast', severity: 'warning', summary: 'Atenção', detail: 'Executado automação de inicio de eleições dentro de 24 horas' });
  }


  iniciarCandidaturasAutomaticamente(){
    let resposta;
    try {
      resposta = this.candidaturasService.getExecInicioCandidaturasAuto(this.token);
    }
    catch {
      return 0
    }
    if (resposta)
      this.messageService.add({ key: 'toast', severity: 'warning', summary: 'Atenção', detail: 'Executado automação de inicio de candidaturas dentro de 24 horas' });
  }

  iniciarAprovacaoAutomaticamente(){
    let resposta;
    try {
      resposta = this.candidaturasService.getExecInicioAprovacaoAuto(this.token);
    }
    catch {
      return 0
    }
    if (resposta)
      this.messageService.add({ key: 'toast', severity: 'warning', summary: 'Atenção', detail: 'Executado automação de inicio de candidaturas dentro de 24 horas' });
  }

  public abrirModalSenha(id){
    this.gestorModalSelecionado = id;
    this.password = null;
  }

  public abrirModalSenhaAssistente(id){
    this.assistenteModalSelecionado = id;
    this.password = null;
  }

  public alterarSenhaGestor(idGestor){
    let senha = this.formGroup.get('senha').value
    let confirmacaoSenha = this.formGroup.get('confirmacaoSenha').value

    if(senha == confirmacaoSenha){
      event.preventDefault();
      this.gestor.senha = this.formGroup.get('senha').value
      this.formGroup.reset();

      this.token = sessionStorage.getItem('token');
      this.gestores.alterarSenhaGestor(this.token,idGestor,this.gestor.senha).then((data: GestorDTO) => {
        this.resposta = data;
        console.log("resposta",JSON.stringify(this.resposta))
        
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Senha alterada com sucesso!" });
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error",error)
      });
    }else{
      alert("As senhas não conferem! Por favor, corrija.")
    }
  }

  public alterarSenhaAssistente(idAssistente){
    let senha = this.formGroup.get('senha').value
    let confirmacaoSenha = this.formGroup.get('confirmacaoSenha').value

    if(senha == confirmacaoSenha){
      event.preventDefault();
      this.assistente.senha = this.formGroup.get('senha').value
      this.formGroup.reset();

      this.token = sessionStorage.getItem('token');
      this.gestores.alterarSenhaAssistente(this.token,idAssistente,this.assistente.senha).then((data: GestorDTO) => {
        this.resposta = data;
        console.log("resposta",JSON.stringify(this.resposta))
        
        this.messageService.add({ key: 'toast', severity: 'success', summary: 'Atenção', detail: "Senha alterada com sucesso!" });
      }, error => {
        this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
        console.log("error",error)
      });
    }else{
      alert("As senhas não conferem! Por favor, corrija.")
    }
  }

  public obterSenhaPreview(idGestor) {
    const token = sessionStorage.getItem('token');
    this.gestores.getPreviewKey(token, idGestor).then((data) => {
      if (data && data['key']) {
        this.password = data['key'];
      }
    }, error => {
      this.messageService.add({ key: 'toast', severity: 'error', summary: 'Atenção', detail: error });
    });
  }
}